// Updated constants file
const GOOGLE_API_KEY =
  process.env.REACT_APP_GOOGLE_API_KEY ||
  "AIzaSyBwVYWTBqXZb3rpWJmgzh54XnzKS6hTuBU";
const IMAGE_URL_AZURE =
  process.env.REACT_APP_IMAGE_TOKEN_AZURE ||
  "sp=r&st=2023-09-03T09:14:50Z&se=2025-09-03T17:14:50Z&spr=https&sv=2022-11-02&sr=c&sig=iZvMW0xmkQvxy27%2F6c3tkT30a%2F966cNNeKf%2BHSLiS54%3D";

export { GOOGLE_API_KEY, IMAGE_URL_AZURE };
